/* Class for generating a page tag */

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, TAG_TYPES, USER_TYPES, TAG_OWNER_TYPES, PAGE_TYPES } = require('@bcm/constants');
const { DataTableBase } = require('./base.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  tagOwnerType: Joi.string().valid( ...Object.keys(TAG_OWNER_TYPES) ).required(),
  ownerId: Joi.string().valid().required(),
  tagType: Joi.string().valid( TAG_TYPES.page ).required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).optional(),
  pageName: Joi.string().optional(),
  pageId: Joi.string().valid().required(),
  pageType: Joi.string().valid( ...Object.keys(PAGE_TYPES) ).required(),
};

// Define class
class PageTag extends DataTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.pageTag.buildPk(obj.tagOwnerType, obj.ownerId, obj.tagType),
      identifiers.pageTag.buildSk(obj.state, obj.pageId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] !== undefined) {
        if(obj[key]) {
          this[key] = obj[key];
        }
      }
    }
  }
}

exports.PageTag = PageTag;
exports.pageTagSchema = schema;
